import React from 'react';
import { TouchableOpacity } from 'react-native';
import { SwapIcon } from './FencingIcons';

/**
 * Componente per il pulsante di inversione lati nei match
 * @param {Object} props - Le proprietà del componente
 * @param {boolean} props.invertiLati - Stato corrente dell'inversione
 * @param {Function} props.toggleInvertiLati - Funzione per invertire i lati
 * @param {Object} props.style - Stile aggiuntivo (opzionale)
 */
const InvertiLatiButton = ({ invertiLati, toggleInvertiLati, style }) => {
  const buttonStyle = {
    backgroundColor: 'rgba(25, 118, 210, 0.8)',
    paddingVertical: 8,
    paddingHorizontal: 8, // Ridotto per icona quadrata
    borderRadius: 25, // Più circolare
    width: 45,
    height: 45,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    ...style
  };

  return (
    <TouchableOpacity
      style={buttonStyle}
      onPress={toggleInvertiLati}
    >
      <SwapIcon style={{ color: '#fff', fontSize: 28 }} />
    </TouchableOpacity>
  );
};

export default InvertiLatiButton;
